import { AuthProvider, AuthSplash, ControleAcessoProvider } from "@omnijus/common";
import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Router } from "./router";
import { CLIENT_ID } from "./services/client-id";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { format } from "date-fns";

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () {
    return format(this, "yyyy-MM-dd HH:mm:ss");
};

const configuration = {
    client_id: "spa-operacional",
    redirect_uri: window.location.origin + "/authentication/callback",
    response_type: "code",
    post_logout_redirect_uri: window.location.origin,
    scope: "openid profile roles email api_bff_operacional",
    authority: process.env.REACT_APP_AUTH_URL,
    silent_redirect_uri: window.location.origin + "/authentication/silent_callback",
    automaticSilentRenew: true,
    loadUserInfo: true,
};

const App = () => {
    return (
        <AuthProvider userManagerSettings={configuration} callbackComponent={<AuthSplash />}>
            <ControleAcessoProvider clientId={CLIENT_ID} baseUrl={process.env.REACT_APP_BFF_OPERACIONAL_API_URL!}>
                <Router />
            </ControleAcessoProvider>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </AuthProvider>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
